import styles from "./ErrorFallback.module.css";
import errorImage from "./bug.svg";

function ErrorFallback({ error }) {
  console.log("Error occured:", error);

  return (
    <div className={styles.container}>
      <img
        src={errorImage}
        alt="Error illustration"
        className={styles.errorImage}
      />
      <p className={styles.message}>Something went wrong.</p>

      <button
        className={styles.retryButton}
        onClick={() => window.location.reload()}
      >
        Refresh page
      </button>

      <br></br>

      <div className={styles.tipsContainer}>
        <h3 className={styles.tipsTitle}>Troubleshooting Tips</h3>
        <ul className={styles.tipsList}>
          <li className={styles.tipItem}>
            <span>Errors like "Loading CSS chunk X failed." often indicate internet connectivity issues.</span>
          </li>
        </ul>
      </div>

      <div className={styles.errorBox}>
        <pre className={styles.errorText}>
          {error.message || String(error)}
        </pre>
      </div>
    </div>
  );
}

export default ErrorFallback;
